import { render, staticRenderFns } from "./RateManagerSuggestionFilter.vue?vue&type=template&id=22fb5b72&scoped=true&"
import script from "./RateManagerSuggestionFilter.vue?vue&type=script&lang=js&"
export * from "./RateManagerSuggestionFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fb5b72",
  null
  
)

export default component.exports